"use client"

import { useEffect } from "react"

import type { BootstrapResponseV2 } from "@/generated/api/types.gen"
import { accountGateway } from "@/platform/api/gateways/account"
import { useScreenVisible } from "@/platform/app-mode/use-screen-visible"
import { setMetaAuthenticatedUserUuid } from "@/platform/observability/analytics/meta/user-identity"
import { useGateway } from "@/platform/session/use-api"
import { usePrivateQuery } from "@/platform/session/use-private-query"

export const useGetBootstrap = (enabled = true, pollInterval: number | false = 5000) => {
  const screenVisible = useScreenVisible()
  const account = useGateway(accountGateway)

  const { data, ...props } = usePrivateQuery<BootstrapResponseV2>({
    queryKey: ["userBootstrap"],
    queryFn: ({ signal }) => account.bootstrap(signal),
    enabled: enabled,
    // Credit balance drives what checkout offers, and this polls every 5s to track it.
    staleTime: 0,
    refetchInterval: screenVisible ? pollInterval : false,
    structuralSharing: true,
  })

  useEffect(() => {
    setMetaAuthenticatedUserUuid(data?.user?.uuid)
  }, [data?.user?.uuid])

  return {
    data,
    ...props,
  }
}
